import { tools } from '@sloyd/tools';
import axios, { AxiosResponse } from 'axios';
import { clone } from 'lodash';
import { invokeEvent } from 'shared-base';
import { axiosApi } from '../globals';
import { parseTextaco } from '../parsers/textaco';
import { References } from '../types';
import { Response } from '../utils/axios';
import * as openAI from '../utils/openAI';

export namespace ai {
  export const create = (prompt: string) => {
    return axiosApi.run('post', '/ai-services/create', {
      prompt: prompt,
    });
  };

  export const edit = async (prompt: string, generator: IGenerator) => {
    let response;

    let outputGenerator: any = clone(generator);

    delete outputGenerator.id;
    delete outputGenerator.createdAt;
    delete outputGenerator.createdBy;
    delete outputGenerator.modifiedAt;
    delete outputGenerator.visibility;
    delete outputGenerator.template;
    delete outputGenerator.groups;
    delete outputGenerator.type;
    delete outputGenerator.groups;
    delete outputGenerator.thumbnailUrl;
    delete outputGenerator.paletteId;
    delete outputGenerator.defaultValues;
    delete outputGenerator.nogMap;
    delete outputGenerator.author;
    delete outputGenerator.order;
    delete outputGenerator.prevId;
    delete outputGenerator.slots;
    delete outputGenerator.tags;

    const payload = {
      prompt: prompt + ' ' + JSON.stringify(outputGenerator),
    };

    try {
      response = await axiosApi.run('post', '/ai-services/edit', payload);
    } catch (err) {
      invokeEvent('sentry', { err });
    }

    return response;
  };

  const uploadIModel = async (model: IModel): Promise<string> => {
    const jsonString = JSON.stringify(model);
    const jsonBlob = new Blob([jsonString], { type: 'application/json' });
    const formData = new FormData();
    formData.append('file', jsonBlob, 'file.json');

    const urlResponse: Response = await axiosApi.run(
      'post',
      'v2/quality/qualityArtifactUpload',
      formData
    );
    return urlResponse.data[0].url;
  };

  export const iModelToGLB = async (model: IModel): Promise<ArrayBuffer> => {
    const response: AxiosResponse<ArrayBuffer> = await axiosApi.internalApi(
      '/internal-api/imodel-to-glb',
      model
    );
    return response.data;
  };

  export const iModelToPNG = async (model: IModel): Promise<ArrayBuffer> => {
    const response: AxiosResponse<ArrayBuffer> = await axiosApi.internalApi(
      '/internal-api/imodel-to-png',
      model
    );
    return response.data;
  };

  // TODO(Rok Kos): Decide with Guy if we need this?
  // taco
  // export const color = async (prompt: string, generatorId: string, materials: MaterialData[]) => {
  //   return axiosTaco.run('post', '/taco', {
  //     text_prompt: prompt,
  //     generator_id: generatorId,
  //     materials: materials,
  //   });
  //
  //   // return IMaterialPack
  // };

  // textaco
  export const texturize = async (prompt: string, generatorId: string, references: References) => {
    const resAi = await axiosApi.run('post', '/ai-services/textaco', {
      prompt: prompt,
      generatorId: generatorId,
    });

    const { data: dataAi } = resAi;
    if (!resAi.isSuccess) {
      Promise.reject(resAi.error);
      return;
    }

    const output = parseTextaco(dataAi, references);

    return {
      isSuccess: true,
      data: output,
    };
  };

  // realtime ephemeral key
  export const realtime = async (token: string) => {
    const voices = ['alloy', 'ash', 'ballad', 'coral', 'echo', 'sage', 'shimmer', 'verse'];
    // const voice = 'echo';
    // const voice = 'shimmer';
    // const voice = 'ash';
    // const voice = 'sage';
    const voice = 'echo';
    // const voice = 'sage';

    // An endpoint which would work with the client code above - it returns
    // the contents of a REST API request to this protected endpoint
    const r = await fetch('https://api.openai.com/v1/realtime/sessions', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model: 'gpt-4o-realtime-preview-2024-12-17',
        voice,
        instructions: '',
        temperature: 0.8,
        tool_choice: 'auto',
        tools,
      }),
    });
    const data = await r.json();

    // Send back the JSON we received from the OpenAI REST API
    return data;
  };

  export const styleTransfer = async (styleDescription: string, base64Image: any) => {
    return openAI.styleTransfer(styleDescription, base64Image);
  };

  export const textTo3d = async (prompt: string, target: string) => {
    try {
      const url = `https://lapis-124265032526.us-central1.run.app/generate/${encodeURI(
        prompt
      )}/model.glb?options=${target}`;
      const res = await axios.post(url, null, { responseType: 'arraybuffer' });

      const blob = new Blob([res.data], { type: 'model/gltf-binary' });
      const blobUrl = URL.createObjectURL(blob);

      // const link = document.createElement('a');
      // link.href = blobUrl;
      // link.download = 'model.glb';
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);

      return {
        isSuccess: true,
        data: blobUrl,
      };
    } catch (err: any) {
      return {
        isSuccess: false,
        error: err.message,
      };
    }
  };
}
